import {
    ACCOUNT_MEMBER_SELECT_QUERY,
    ACCOUNT_MEMBER_SELECT_QUERY_FAIL,
    ACCOUNT_MEMBER_SELECT_QUERY_RESET,
    ACCOUNT_MEMBER_SELECT_QUERY_SET_PARAMS,
    ACCOUNT_MEMBER_SELECT_QUERY_SUCCESS,
} from './constants';

//
export const AccountMemberSelectReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case ACCOUNT_MEMBER_SELECT_QUERY_RESET:
            ret.loading = false;
            ret.params = null;
            ret.queryDatas = null;
            ret.querySuccess = null;
            ret.error = null;
            break;
        case ACCOUNT_MEMBER_SELECT_QUERY_SET_PARAMS:
            ret.params = data.params;
            break;
        case ACCOUNT_MEMBER_SELECT_QUERY:
            ret.loading = true;
            ret.querySuccess = null;
            ret.error = null;
            ret.refresh = false;
            break;
        case ACCOUNT_MEMBER_SELECT_QUERY_SUCCESS:
            ret.loading = false;
            ret.querySuccess = true;
            ret.queryDatas = data.queryDatas;
            ret.params = data.params;
            break;
        case ACCOUNT_MEMBER_SELECT_QUERY_FAIL:
            ret.loading = false;
            ret.querySuccess = false;
            ret.error = data;
            break;
        default:
            return {...state};
    }
    return ret;
}
